export const formatDate = (value?: unknown) => value ? new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(new Date(`${String(value).slice(0, 10)}T12:00:00Z`)) : "—";
export const formatNumber = (value?: unknown) => new Intl.NumberFormat("pt-BR").format(Number(value || 0));
export const text = (value?: unknown) => value === null || value === undefined || value === "" ? "—" : String(value);
export const today = () => new Date().toISOString().slice(0, 10);
export const currentTime = () => new Date().toTimeString().slice(0, 5);
export const onlyDigits = (value?: unknown) => String(value ?? "").replace(/\D/g, "");
export const formatCnpj = (value?: unknown) => {
  const digits = onlyDigits(value).slice(0, 14);
  return digits
    .replace(/^(\d{2})(\d)/, "$1.$2")
    .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1/$2")
    .replace(/(\d{4})(\d)/, "$1-$2");
};

/** Máscara dd/mm/aaaa para digitação. */
export function maskDate(raw: string): string {
  const digits = onlyDigits(raw).slice(0, 8);
  return digits.replace(/^(\d{2})(\d)/, "$1/$2").replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
}
/** AAAA-MM-DD para dd/mm/aaaa ("" quando não for uma data). */
export function isoToBr(iso?: unknown): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso ?? ""));
  return match ? `${match[3]}/${match[2]}/${match[1]}` : "";
}
/** dd/mm/aaaa para AAAA-MM-DD ("" quando incompleta ou inexistente, como 31/02/2026). */
export function brToIso(br?: unknown): string {
  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(String(br ?? "").trim());
  if (!match) return "";
  const [, day, month, year] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  const valid = date.getUTCFullYear() === Number(year) && date.getUTCMonth() === Number(month) - 1 && date.getUTCDate() === Number(day);
  return valid && Number(year) >= 1900 ? `${year}-${month}-${day}` : "";
}
